import { ProductionActionApiWorkLogsWorkLogIdCancelPerformancePutRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { INVENTORIES_KEY } from "api/inventories/useInventoriesQuery";
import { WORK_LOG_GET_KEY } from "api/logs/useWorkLogsGetQuery";
import { WORK_KEY } from "api/work/useWorkQuery";
import { ProductionInstance } from "instance/axios";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { customNotification } from "utils/notificationShow";

//삭제
const fetchWorkLogsWorkLogIdCancelPerformancePut = ({
    workLogId,
    workLogsWorkLogIdCancelInputPutRequest
}: ProductionActionApiWorkLogsWorkLogIdCancelPerformancePutRequest) =>
    ProductionInstance.workLogsWorkLogIdCancelPerformancePut({
        workLogId,
        workLogsWorkLogIdCancelInputPutRequest,
    });

export const useWorkLogsWorkLogIdCancelPerformancePut = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation(
        ({
            workLogId,
            workLogsWorkLogIdCancelInputPutRequest,
        }: ProductionActionApiWorkLogsWorkLogIdCancelPerformancePutRequest) =>
            fetchWorkLogsWorkLogIdCancelPerformancePut({ workLogId, workLogsWorkLogIdCancelInputPutRequest }),
        {
            onSuccess: () => {
                customNotification.success({
                    message: t("실적이 성공적으로 취소되었습니다."),
                });
                queryClient.invalidateQueries(WORK_KEY)
                queryClient.invalidateQueries(WORK_LOG_GET_KEY);
                queryClient.invalidateQueries(INVENTORIES_KEY);
            },
            onError: (error: any) => {
                customNotification.error({
                    message: error.response.data.message
                });
            }
        }
    );
};
export default useWorkLogsWorkLogIdCancelPerformancePut;
